interface ShouldRunWorkingHoursSaveParams {
  readonly changedMonthCount: number;
  readonly companyId: number | undefined;
  readonly handledSaveRequest: number;
  readonly isSaveInFlight: boolean;
  readonly saveRequest: number;
}

export function parseWorkingHours(value: string): number {
  if (!/^\d+$/.test(value)) return 0;

  const hours = Number(value);
  return Number.isSafeInteger(hours) ? hours : 0;
}

export function shouldRunWorkingHoursSave({
  changedMonthCount,
  companyId,
  handledSaveRequest,
  isSaveInFlight,
  saveRequest,
}: ShouldRunWorkingHoursSaveParams): boolean {
  return (
    saveRequest !== 0 &&
    saveRequest !== handledSaveRequest &&
    companyId != null &&
    !isSaveInFlight &&
    changedMonthCount > 0
  );
}
